// extracted by mini-css-extract-plugin
module.exports = {"rightLeftButtons":"RightLeftButtons_rightLeftButtons__2GE6A"};